module.exports = __webpack_public_path__ + "static/media/computer.d2b6bfe6.png";